import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import { useHistory } from 'react-router-dom';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { useLocaleContext } from '../context/LocaleContext';

const RegistrationModel = ({ show, labels }) => {
  const [showModal, setShowModal] = useState(show);
  const focusElementOnClose = useRef(null);
  const local = useLocaleContext()
  const { 
    confirmationDialog1: 
    { emailConfirmation, confirmationMessage, close }
  } = local === 'en-US' ? EN : FR;
  const history = useHistory();
  const closeModal = () => {
    setShowModal(false);
    history.push(`/login`);
  };
  const proceed = () => {
    setShowModal(false);
    history.push(`/login`);
  };

  return (
    <div>
      <Modal
        heading={emailConfirmation}
        bodyText={confirmationMessage}
        // confirmCTAText={close}
        focusElementAfterClose={focusElementOnClose}
        onConfirm={proceed}
        onClose={closeModal}
        isOpen={showModal}
      />
    </div>
  );
};

RegistrationModel.defaultProps = {
  show: false
};

RegistrationModel.propTypes = {
  show: PropTypes.bool,
  labels: PropTypes.shape({
    emailConfirmation: PropTypes.string,
    confirmationMessage: PropTypes.string,
    close: PropTypes.string
  }).isRequired
};

export default RegistrationModel;
